import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useShareLink } from "./api";
import { ReviewRoom } from "./ReviewRoom";
import { useHomeScreen } from "./shell";

// RV-7 — a review opened from a share link (/r/<code>): no sign-in, just that one review.
export function SharedReview() {
  const { token = "" } = useParams();
  const [ready, setReady] = useState(false);
  useHomeScreen("Review");
  useEffect(() => { useShareLink(token); setReady(true); return () => useShareLink(null); }, [token]);
  return ready ? <ReviewRoom shared /> : null;
}
